const largeSizeChecker = (codeName: string) => {
  const largeSize = [
    "name",
    "plus_code",
    "pavement_description",
    "site_description",
    "nearby_competitor_info",
    "external_environmental_factor",
    "parking_note",
    "contract_term",
  ];
  return !!largeSize.find((str) => str === codeName);
};

export const getLayoutSize = (codeName: string) => {
  if (largeSizeChecker(codeName)) return 12;
  return 6;
};

export const getLayoutType = (type: string) => {
  if (type === "decimal" || type === "number") return "text";
  return type;
};

export const getContractLocation = (location: any) => {
  if (!location) return "";
  const { city, district, ward, street_name, address_number } = location;
  let res = "";
  if (city?.name) {
    res += `${city?.name}`;
  }
  if (district?.name) {
    res += `, ${district?.name}`;
  }
  if (ward?.name) {
    res += `, ${ward?.name}`;
  }
  if (address_number) {
    res += `, ${address_number}`;
  }
  if (street_name) {
    res += ` ${street_name}`;
  }
  return res;
};
